document.addEventListener('DOMContentLoaded', function() {
  function initLocalization() {
    // Handle ALL triggers (both original and header mode)
    const allTriggers = document.querySelectorAll('[data-localization-trigger]');
    
    allTriggers.forEach(trigger => {
      // Remove existing listener to avoid duplicates
      trigger.removeEventListener('click', trigger._handler);
      
      // Create and store the handler
      const handler = (e) => {
        e.stopPropagation();
        const type = trigger.getAttribute('data-localization-trigger');
        
        // Find dropdown - FIRST look for dropdown within the same container/parent
        let dropdown = null;
        
        // Method 1: Look for dropdown in the same parent container (.custom-localization)
        const parentContainer = trigger.closest('.custom-localization, .custom-localization--header-mode, .localization-form');
        if (parentContainer) {
          dropdown = parentContainer.querySelector(`[data-localization-dropdown="${type}"]`);
        }
        
        // Method 2: If not found, look for dropdown that is a sibling or near the trigger
        if (!dropdown) {
          dropdown = trigger.parentElement?.querySelector(`[data-localization-dropdown="${type}"]`);
        }
        
        // Method 3: If still not found, look for dropdown with matching type but NOT the one in header if trigger is in footer
        if (!dropdown) {
          const allDropdowns = document.querySelectorAll(`[data-localization-dropdown="${type}"]`);
          // If there are multiple dropdowns (header + footer), find the one closest to the trigger
          if (allDropdowns.length > 1) {
            let closestDropdown = null;
            let closestDistance = Infinity;
            const triggerRect = trigger.getBoundingClientRect();
            allDropdowns.forEach(d => {
              const dropdownRect = d.getBoundingClientRect();
              const distance = Math.abs(dropdownRect.top - triggerRect.top);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestDropdown = d;
              }
            });
            dropdown = closestDropdown;
          } else if (allDropdowns.length === 1) {
            dropdown = allDropdowns[0];
          }
        }
        
        if (!dropdown) {
          console.error('Dropdown not found for type:', type);
          return;
        }
        
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close all dropdowns in the same container only (not all dropdowns on page)
        if (parentContainer) {
          parentContainer.querySelectorAll('[data-localization-dropdown]').forEach(d => {
            if (d !== dropdown) {
              d.setAttribute('hidden', true);
              const otherTrigger = parentContainer.querySelector(`[data-localization-trigger="${d.getAttribute('data-localization-dropdown')}"]`);
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        } else {
          // Fallback: close only dropdowns of the same type
          document.querySelectorAll(`[data-localization-dropdown="${type}"]`).forEach(d => {
            if (d !== dropdown) {
              d.setAttribute('hidden', true);
            }
          });
        }
        
        if (isExpanded) {
          dropdown.setAttribute('hidden', true);
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          dropdown.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
          
          // Focus search input if exists
          const search = dropdown.querySelector('[data-localization-search]');
          if (search) setTimeout(() => search.focus(), 100);
        }
      };
      
      trigger._handler = handler;
      trigger.addEventListener('click', handler);
    });
    
    // Close buttons handler
    const closeButtons = document.querySelectorAll('[data-localization-close]');
    closeButtons.forEach(btn => {
      btn.removeEventListener('click', btn._handler);
      const handler = () => {
        const dropdown = btn.closest('[data-localization-dropdown]');
        if (dropdown) {
          dropdown.setAttribute('hidden', true);
          const type = dropdown.getAttribute('data-localization-dropdown');
          // Find the trigger that belongs to this dropdown's container
          const parentContainer = dropdown.closest('.custom-localization, .custom-localization--header-mode, .localization-form');
          let trigger = null;
          if (parentContainer) {
            trigger = parentContainer.querySelector(`[data-localization-trigger="${type}"]`);
          }
          if (!trigger) {
            trigger = document.querySelector(`[data-localization-trigger="${type}"]`);
          }
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      };
      btn._handler = handler;
      btn.addEventListener('click', handler);
    });
    
    // Search functionality
    const searchInputs = document.querySelectorAll('[data-localization-search]');
    searchInputs.forEach(input => {
      input.removeEventListener('input', input._handler);
      const handler = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        const dropdown = input.closest('[data-localization-dropdown]');
        const items = dropdown.querySelectorAll('.custom-localization__item-li');
        
        items.forEach(item => {
          const text = item.textContent.toLowerCase();
          if (text.includes(searchTerm)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      };
      input._handler = handler;
      input.addEventListener('input', handler);
    });
    
    // Link click handlers (country/language selection)
    const links = document.querySelectorAll('.custom-localization__link');
    links.forEach(link => {
      link.removeEventListener('click', link._handler);
      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const selectedValue = link.getAttribute('data-value');
        const dropdown = link.closest('[data-localization-dropdown]');
        const isCountry = dropdown && dropdown.getAttribute('data-localization-dropdown') === 'country';
        
        // Find the localization form
        let form = document.querySelector('#FooterLocalizationForm');
        if (!form) {
          form = document.querySelector('form[action="/localization"]');
        }
        if (!form) {
          form = document.querySelector('form.localization-form');
        }
        
        if (form) {
          if (isCountry) {
            let countryInput = form.querySelector('input[name="country_code"]');
            if (!countryInput) {
              countryInput = document.createElement('input');
              countryInput.type = 'hidden';
              countryInput.name = 'country_code';
              form.appendChild(countryInput);
            }
            countryInput.value = selectedValue;
          } else {
            let languageInput = form.querySelector('input[name="locale_code"]');
            if (!languageInput) {
              languageInput = document.createElement('input');
              languageInput.type = 'hidden';
              languageInput.name = 'locale_code';
              form.appendChild(languageInput);
            }
            languageInput.value = selectedValue;
          }
          
          // Close dropdown before submit
          if (dropdown) dropdown.setAttribute('hidden', true);
          
          // Find the correct trigger for this dropdown
          const parentContainer = dropdown?.closest('.custom-localization, .custom-localization--header-mode, .localization-form');
          let trigger = null;
          if (parentContainer) {
            trigger = parentContainer.querySelector(`[data-localization-trigger="${isCountry ? 'country' : 'language'}"]`);
          }
          if (!trigger) {
            trigger = document.querySelector(`[data-localization-trigger="${isCountry ? 'country' : 'language'}"]`);
          }
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          
          // Submit the form
          form.submit();
        } else {
          // Fallback: direct navigation
          const currentUrl = new URL(window.location.href);
          if (isCountry) {
            currentUrl.searchParams.set('country_code', selectedValue);
          } else {
            currentUrl.searchParams.set('locale_code', selectedValue);
          }
          window.location.href = currentUrl.toString();
        }
      };
      link._handler = handler;
      link.addEventListener('click', handler);
    });
  }
  
  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    const isTrigger = e.target.closest('[data-localization-trigger]');
    const isDropdown = e.target.closest('[data-localization-dropdown]');
    
    if (!isTrigger && !isDropdown) {
      // Close all dropdowns
      document.querySelectorAll('[data-localization-dropdown]').forEach(dropdown => {
        dropdown.setAttribute('hidden', true);
      });
      document.querySelectorAll('[data-localization-trigger]').forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
  
  initLocalization();
});